<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Acesso a AI do Resulth pelo Whatsapp</h1>
    <p class="welcome-message">
      <button mat-icon-button routerLink="../">
        <mat-icon>arrow_back</mat-icon>
      </button>
      Cadastre os números de whatsapp para ter acesso a AI integrada com o Resulth
    </p>

    <!-- Seção Como Funciona -->
    <div class="section-container mb-4">
      <div class="section-title">
        <mat-icon>help_outline</mat-icon>
        <span>Como funciona</span>
      </div>

      <div class="action-card-grid mt-3">
        <app-action-card icon="smart_toy" title="Acesso apenas aos dados do Resulth"
          description="Esta IA tem acesso apenas aos dados do Resulth.">
        </app-action-card>

        <app-action-card icon="storage" title="Resulth Local Connect instalado">
          Para a IA acessar o Resulth, o Resulth Local Connect deve estar instalado na empresa.
          <a routerLink="/integracao/resulth-local-connect" class="saiba-mais-link">Configurar Local Connect</a>
        </app-action-card>

        <app-action-card icon="wifi" title="Servidor ligado e com internet"
          description="Para funcionar, o servidor do banco de dados e o Resulth Local Connect precisam estar ligados e com acesso à internet.">
        </app-action-card>
      </div>
    </div>

    <form class="form" [formGroup]="model" (ngSubmit)="submit()">
      @if (!isMultiEmpresa) {
      @if (empresas.length > 0) {
      <ng-container [ngTemplateOutlet]="listaNumerosTemplate"
        [ngTemplateOutletContext]="{ empresaGroup: empresas.controls[0], indexEmpresa: 0 }">
      </ng-container>
      }
      } @else {
      <div class="row">
        <div class="col-md-12">
          <p class="mb-2">Empresa matriz: edite os números de WhatsApp de cada filial do grupo.</p>
        </div>
      </div>

      <mat-accordion class="mb-3 empresa-accordion" multi>
        @for (empresaGroup of empresas.controls; track empresaGroup; let indexEmpresa = $index) {
        <mat-expansion-panel class="empresa-panel"
          [expanded]="empresaGroup.get('idEmpresa')?.value === userLoginResponse.idEmpresa">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ empresaGroup.get('nomeEmpresa')?.value }}
              <span class="empresa-panel-cnpj">{{ empresaGroup.get('cnpj')?.value | cpfCnpj }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ng-container [ngTemplateOutlet]="listaNumerosTemplate"
            [ngTemplateOutletContext]="{ empresaGroup: empresaGroup, indexEmpresa: indexEmpresa }">
          </ng-container>
        </mat-expansion-panel>
        }
      </mat-accordion>
      }

      <div class="section-container">
        <div class="section-title">
          <mat-icon>chat</mat-icon>
          <span>Converse com a IA via WhatsApp</span>
        </div>
        <p>
          Escaneie o código QR code para começar a conversar com nossos agentes de IA diretamente do seu
          Whatsapp.
        </p>
        <div class="col-md-12 text-center">
          <img class="logo-auth mx-auto d-block" src="assets/images/qr-code-whatsapp.png" />
        </div>
      </div>
    </form>
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isPageLoading" [isSalvarDisabled]="btnSalvarDisabled" (cancelar)="voltar()"
  (salvar)="submit()">
</app-footer-action>

<ng-template #listaNumerosTemplate let-empresaGroup="empresaGroup" let-indexEmpresa="indexEmpresa">
  <div class="row" [formGroup]="empresaGroup">
    <div class="col-md-8" [formArrayName]="'listaNumeros'">
      <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
        <p class="mb-0 lista-numeros-title">Números de Whatsapp</p>
        <button type="button" mat-button (click)="adicionarItemLista(indexEmpresa)" [disabled]="btnSalvarDisabled"
          matTooltip="Adicionar novo número">
          <mat-icon>add</mat-icon> Adicionar
        </button>
      </div>

      @for (item of listaNumerosDe(empresaGroup).controls; track item; let indexNumero = $index) {
      <div [formGroupName]="indexNumero" class="row w-100 g-2 align-items-center m-0 mb-2">
        <div class="col-5">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-label>Número de Whatsapp</mat-label>
            <input matInput formControlName="numero" placeholder="Número de Whatsapp" [mask]="masks.phone"
              type="text" />
            @if (item.get('numero')?.invalid) {
            <mat-error>Informe um número</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col-5">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
            <mat-label>Agentes de IA</mat-label>
            <mat-select formControlName="listaIdAiAgent" multiple>
              @for (agent of _listaAiAgentResponse.listaAiAgent; track agent) {
              <mat-option [value]="agent.idAiAgent">
                {{ agent.nome }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-2 produto-grid-delete-col">
          <button mat-icon-button type="button" class="produto-grid-delete-button"
            (click)="removerItemLista(indexEmpresa, indexNumero)" [disabled]="btnSalvarDisabled" matTooltip="Remover">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</ng-template>
